package com.ijoin.data.model

import com.ijoin.data.model.serialization.InstantIso8601Serializer
import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable

@Serializable
data class EventCapacity(
    val eventId: String,
    @Serializable(with = InstantIso8601Serializer::class)
    val occurrenceDateTime: Instant,
    val remainingTickets: Int? = null,
    val maxCapacity: Int? = null,
)

@Serializable
data class EventCapacityBatchRequest(
    val occurrences: List<@Serializable(with = InstantIso8601Serializer::class) Instant>,
)
